// @ts-expect-error TS(7016): Could not find a declaration file for module '@nos...
import SortableTree from "@nosferatu500/react-sortable-tree"
import { ProgressSpinner } from "primereact/progressspinner"

import Checkbox from "common/components/Checkbox"
import "./catalogosTree.scss"

const CatalogosTree = ({
  visible = true,
  items,
  setItems,
  selectCategorias,
  unSelectCategorias,
  articulosSelected,
  loading = false,
  maxHeight,
}: $TSMigrationFixMe) => {
  return (
    <div
      style={{ height: maxHeight }}
      className={`container-tree ${!visible ? "hide" : ""}`}
    >
      <div className='catalogos-tree-wrap'>
        {loading ? (
          <ProgressSpinner
            style={{
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        ) : (
          <SortableTree
            canDrop={() => false}
            treeData={items}
            onChange={(changes: $TSMigrationFixMe) => setItems(changes)}
            generateNodeProps={({ node, path }: $TSMigrationFixMe) => {
              const allArticulosSelected =
                articulosSelected?.[node.title]?.articulos?.length ===
                node.cantidadArticulos
              const isChecked = articulosSelected?.[node.title]

              return {
                title: (
                  <div className='d-flex align-items-center'>
                    <Checkbox
                      toggle={() => {
                        if (!isChecked) {
                          selectCategorias({ node, path })
                        } else {
                          unSelectCategorias({ node, path })
                        }
                      }}
                      checked={isChecked}
                      notEvery={isChecked && !allArticulosSelected}
                    />
                    <span className='ml-2'>
                      {node.title} ({node.cantidadArticulos})
                    </span>
                  </div>
                ),
              }
            }}
          />
        )}
      </div>
    </div>
  )
}

export default CatalogosTree
